import React from 'react';
import Chip from '@material-ui/core/Chip';
import VolumeOff from '@material-ui/icons/VolumeOff';
import Pause from '@material-ui/icons/Pause';
import VolumeUp from '@material-ui/icons/VolumeUp';
import Fab from '@material-ui/core/Fab';

import { audioPlayer } from '../../utils/audio';

export default class AudioChunkBuffer extends React.Component<Props, State> {
  constructor() {
    super();
    this.state = {
      secondsBehind: 0,
      state: undefined,
      speed: 1,
      gain: 1,
      delay: undefined,
      paused: undefined,
    };
  }

  componentDidMount() {
    audioPlayer.register(this);
  }

  componentWillUnmount() {
    audioPlayer.unregister(this);
  }

  updateSpeed() {
    const { speed } = this.state;
    audioPlayer.updateSpeed(speed === 1 ? 1.05 : 1);
  }

  // eslint-disable-next-line
  jumpToDelay() {
    return audioPlayer.jumpToDelay();
  }

  render() {
    const { secondsBehind, state, delay, speed, paused, gain } = this.state;
    const { currentPlatform, isInConversation } = this.props;
    let secondsBehindS = `${secondsBehind}`;
    if (!secondsBehindS.includes('.')) {
      secondsBehindS = `${secondsBehindS}.0`;
    }
    if (currentPlatform === 'web' && !isInConversation) {
      return null;
    }
    const customGain = (gain - 1) ** 2 > 0.0001;
    return (
      <div
        style={{
          display: 'flex',
          flexDirection: 'row',
        }}
      >
        {state === 'suspended' && (
          <Fab style={{ marginLeft: 'auto' }}>
            <VolumeOff />
          </Fab>
        )}
        {speed !== 1 && (
          <Chip
            onClick={() => this.updateSpeed()}
            color="primary"
            label={`${speed * 100}%`}
            style={{ width: 50 }}
          />
        )}
        {(state === 'running' || state === 'closed') && delay && (
          <div
            style={{
              padding: 2,
              paddingRight: 5,
              paddingLeft: 5,
              marginRight: 10,
              marginLeft: 10,
              display: 'flex',
              flexDirection: 'row',
            }}
          >
            <div
              style={{
                borderBottomLeftRadius: 7,
                margin: 'auto',
                display: 'flex',
                placeContent: 'center',
                flexDirection: 'row',
                borderTopLeftRadius: 7,
                width: 60,
                backgroundColor: paused ? 'red' : 'darkgreen',
              }}
            >
              {paused && <Pause style={{ fontSize: 16, marginTop: 3 }} />}
              {!paused && <VolumeUp style={{ fontSize: 16, marginTop: 3 }} />}
              <div>{secondsBehindS}</div>
            </div>
            <div
              style={{
                whiteSpace: 'nowrap',
                borderTopRightRadius: 7,
                borderBottomRightRadius: 7,
                backgroundColor: 'darkgreen',
                minWidth: 7,
                width: 35,
                margin: 'auto',
                placeContent: 'center',
                display: 'flex',
              }}
            >
              {customGain && <>{Math.round(gain * 100)}%</>}
            </div>
          </div>
        )}
      </div>
    );
  }
}
